import { render, staticRenderFns } from "./ProcessModal.vue?vue&type=template&id=4985951a&scoped=true"
import script from "./ProcessModal.vue?vue&type=script&lang=js"
export * from "./ProcessModal.vue?vue&type=script&lang=js"
import style0 from "./ProcessModal.vue?vue&type=style&index=0&id=4985951a&prod&lang=scss"
import style1 from "./ProcessModal.vue?vue&type=style&index=1&id=4985951a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985951a",
  null
  
)

export default component.exports